//login.js
import request from '@/utils/request';

export function register(data) {
  return request({
    url: '/v1/user_info/register',
    method: 'post',
    data: data,
  });
}

export function getRegisterVerifyCode(data) {
  return request({
    url: '/v1/user_info/reg_verify_code',
    method: 'post',
    data: data,
  });
}

export function sendLoginCode(data) {
  return request({
    url: `/v1/user_info/send_login_code`,
    method: 'post',
    data: data,
  });
}

export function loginByCode(data) {
  return request({
    url: `/v1/user_info/login_by_code`,
    method: 'post',
    data: data,
  });
}

export function checkEmail(data) {
  return request({
    url: `/v1/user_info/check_email`,
    method: 'post',
    data,
  });
}

export function getRegisterPhoneVerifyCode(data) {
  return request({
    url: `/v1/user_info/send_sms_reg_code`,
    method: 'post',
    data,
  });
}
